import React, { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useTranslation } from "react-i18next";
import { markDashboardTourDone } from "./dashboardPrefs";

type Props = {
  open: boolean;
  onClose: () => void;
};

const STEPS = ["next", "quota", "digest", "done"] as const;

/**
 * Tour curto pós-setup — 4 passos sem lib externa.
 * Por quê: Carla não lê docs no 1º login; aponta o que importa na home.
 */
const DashboardTour = ({ open, onClose }: Props) => {
  const { t } = useTranslation();
  const [step, setStep] = useState(0);

  const finish = () => {
    markDashboardTourDone();
    onClose();
  };

  const current = STEPS[step] ?? "done";

  return (
    <Modal isOpen={open} toggle={finish} centered>
      <ModalHeader toggle={finish}>
        {t("dashboard.tour.title")}
      </ModalHeader>
      <ModalBody>
        <p className="text-muted small mb-2">
          {t("dashboard.tour.stepOf", {
            current: step + 1,
            total: STEPS.length,
          })}
        </p>
        <h5 className="mb-2">{t(`dashboard.tour.${current}.title`)}</h5>
        <p className="mb-0">{t(`dashboard.tour.${current}.body`)}</p>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={finish}>
          {t("dashboard.tour.skip")}
        </Button>
        {step < STEPS.length - 1 ? (
          <Button color="primary" onClick={() => setStep((s) => s + 1)}>
            {t("dashboard.tour.next")}
          </Button>
        ) : (
          <Button color="primary" onClick={finish}>
            {t("dashboard.tour.finish")}
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default DashboardTour;
